import React from 'react';

const PreliminaryInformationPage = () => {
  return (
    <div className="min-h-screen bg-gray-50 py-12">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="bg-white shadow-lg rounded-lg p-8">
          <h1 className="text-3xl font-bold text-gray-900 mb-8">
            Ön Bilgilendirme Formu
          </h1>
          
          <div className="prose prose-lg max-w-none">
            <p className="mb-6 text-gray-600 italic">
              6502 sayılı Tüketicinin Korunması Hakkında Kanun'un 6. maddesi 
              ve Mesafeli Sözleşmeler Yönetmeliği uyarınca hazırlanmıştır.
            </p>
            
            <h2 className="text-xl font-semibold mb-4">1. SATICI BİLGİLERİ</h2>
            <div className="bg-gray-100 p-6 rounded-lg mb-6">
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                <div>
                  <p><strong>Ünvan:</strong> Fiel Home</p>
                  <p><strong>Faaliyet Konusu:</strong> Mobilya ve Mobilya Aksesuarları Toptan Ticareti</p>
                  <p><strong>Faaliyet Kodu:</strong> 464701</p>
                  <p><strong>Vergi Kimlik No:</strong> 7661111486</p>
                </div>
                <div>
                  <p><strong>Vergi Dairesi:</strong> İnegöl</p>
                  <p><strong>Telefon:</strong> +90 552 229 90 07</p>
                  <p><strong>E-posta:</strong> info@fielhome.com</p>
                  <p><strong>Web Sitesi:</strong> www.fielhome.com</p>
                </div>
              </div>
              <div className="mt-4">
                <p><strong>Adres:</strong> MAHMUDİYE MAH. ERTUĞRUL GAZİ CAD. NO: 46 A İNEGÖL/BURSA</p>
                <p><strong>Mağaza Adresi:</strong> Mahmudiye, Ankara Cd. No:90, 16400 İnegöl/Bursa</p>
              </div>
            </div>
            
            <h2 className="text-xl font-semibold mb-4">2. ÜRÜN/HİZMET BİLGİLERİ</h2>
            <h3 className="text-lg font-semibold mb-3">2.1. Ürün Özellikleri</h3>
            <p className="mb-4">
              Satış konusu ürünlerin temel özelikleri, model, renk, adet ve 
              fiyat bilgileri ürün sayfalarında detaylı olarak yer almaktadır.
            </p>
            
            <h3 className="text-lg font-semibold mb-3">2.2. Fiyat ve Ödeme Bilgileri</h3>
            <ul className="list-disc list-inside mb-4 space-y-2">
              <li>Tüm fiyatlar Türk Lirası (TL) olarak belirtilmiştir</li>
              <li>Fiyatlara %20 KDV dahildir</li>
              <li>Kredi kartı, banka kartı, havale/EFT ile ödeme yapılabilir</li>
              <li>Taksit seçenekleri ürün sayfasında gösterilir</li>
              <li>Kampanyalı fiyatlar stok tükene kadar geçerlidir</li>
            </ul>
            
            <h2 className="text-xl font-semibold mb-4">3. TESLİMAT BİLGİLERİ</h2>
            <h3 className="text-lg font-semibold mb-3">3.1. Teslimat Süreleri</h3>
            <div className="overflow-x-auto">
              <table className="min-w-full bg-white border border-gray-300 mb-4">
                <thead className="bg-gray-100">
                  <tr>
                    <th className="border border-gray-300 px-4 py-2 text-left">Ürün Kategorisi</th>
                    <th className="border border-gray-300 px-4 py-2 text-left">Teslimat Süresi</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td className="border border-gray-300 px-4 py-2">Stokta Bulunan Ürünler</td>
                    <td className="border border-gray-300 px-4 py-2">3-7 iş günü</td>
                  </tr>
                  <tr>
                    <td className="border border-gray-300 px-4 py-2">Sipariş Üzerine Üretim</td>
                    <td className="border border-gray-300 px-4 py-2">15-30 iş günü</td>
                  </tr>
                  <tr>
                    <td className="border border-gray-300 px-4 py-2">Özel Tasarım Ürünler</td>
                    <td className="border border-gray-300 px-4 py-2">30-45 iş günü</td>
                  </tr>
                  <tr>
                    <td className="border border-gray-300 px-4 py-2">İthal Ürünler</td>
                    <td className="border border-gray-300 px-4 py-2">20-40 iş günü</td>
                  </tr>
                </tbody>
              </table>
            </div>
            
            <h3 className="text-lg font-semibold mb-3">3.2. Kargo ve Montaj</h3>
            <ul className="list-disc list-inside mb-4 space-y-2">
              <li>Kargo ücreti sepet tutarına göre hesaplanır</li>
              <li>500 TL ve üzeri alışverişlerde kargo ücretsizdir</li>
              <li>Büyük mobilyalar için özel taşıma hizmeti sunulur</li>
              <li>Montaj hizmeti ek ücret karşılığında sağlanır</li>
              <li>Teslimat saatleri: Hafta içi 09:00-18:00</li>
            </ul>
            
            <h2 className="text-xl font-semibold mb-4">4. ÖDEME BİLGİLERİ</h2>
            <h3 className="text-lg font-semibold mb-3">4.1. Ödeme Yöntemleri</h3>
            <ul className="list-disc list-inside mb-4 space-y-2">
              <li><strong>Kredi Kartı:</strong> Visa, MasterCard, American Express</li>
              <li><strong>Banka Kartı:</strong> Troy, Visa Electron, MasterCard</li>
              <li><strong>Havale/EFT:</strong> Sipariş sonrası hesap bilgileri gönderilir</li>
              <li><strong>Kapıda Ödeme:</strong> Belirli ürünlerde nakit/kartla ödeme</li>
            </ul>
            
            <h3 className="text-lg font-semibold mb-3">4.2. Taksit Seçenekleri</h3>
            <div className="overflow-x-auto">
              <table className="min-w-full bg-white border border-gray-300 mb-4">
                <thead className="bg-gray-100">
                  <tr>
                    <th className="border border-gray-300 px-4 py-2 text-left">Banka</th>
                    <th className="border border-gray-300 px-4 py-2 text-left">Taksit Sayısı</th>
                    <th className="border border-gray-300 px-4 py-2 text-left">Faiz Oranı</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td className="border border-gray-300 px-4 py-2">Tüm Bankalar</td>
                    <td className="border border-gray-300 px-4 py-2">2-3 Taksit</td>
                    <td className="border border-gray-300 px-4 py-2">Faizsiz</td>
                  </tr>
                  <tr>
                    <td className="border border-gray-300 px-4 py-2">Seçili Bankalar</td>
                    <td className="border border-gray-300 px-4 py-2">6-9 Taksit</td>
                    <td className="border border-gray-300 px-4 py-2">Faizli</td>
                  </tr>
                  <tr>
                    <td className="border border-gray-300 px-4 py-2">Özel Kampanyalar</td>
                    <td className="border border-gray-300 px-4 py-2">12-24 Taksit</td>
                    <td className="border border-gray-300 px-4 py-2">Kampanyalı</td>
                  </tr>
                </tbody>
              </table>
            </div>
            
            <h2 className="text-xl font-semibold mb-4">5. CAYMA HAKKI</h2>
            <h3 className="text-lg font-semibold mb-3">5.1. Cayma Hakkı Süresi</h3>
            <p className="mb-4">
              Tüketiciler, ürün teslim tarihinden itibaren <strong>14 gün</strong> 
              içinde herhangi bir gerekçe göstermeksizin sözleşmeden cayabilir.
            </p>
            
            <h3 className="text-lg font-semibold mb-3">5.2. Cayma Hakkının Kullanılması</h3>
            <ul className="list-disc list-inside mb-4 space-y-2">
              <li>Cayma bildirimini yazılı olarak yapmanız gerekmektedir</li>
              <li>Ürün kullanılmamış ve orijinal ambalajında olmalıdır</li>
              <li>İade kargo masrafı tüketiciye aittir</li>
              <li>Para iadesi 10 iş günü içinde yapılır</li>
            </ul>
            
            <h3 className="text-lg font-semibold mb-3">5.3. Cayma Hakkının Kullanılamadığı Durumlar</h3>
            <ul className="list-disc list-inside mb-4 space-y-2">
              <li>Tüketicinin istekleri doğrultusunda özel olarak hazırlanan ürünler</li>
              <li>Hijyen açısından iade edilmesi uygun olmayan ürünler</li>
              <li>Montajı yapılan ve kullanılan mobilyalar</li>
              <li>Ölçüye özel kesilmiş ürünler</li>
            </ul>
            
            <h2 className="text-xl font-semibold mb-4">6. GARANTİ BİLGİLERİ</h2>
            <h3 className="text-lg font-semibold mb-3">6.1. Üretici Garantisi</h3>
            <ul className="list-disc list-inside mb-4 space-y-2">
              <li>Tüm ürünler için üretici garantisi geçerlidir</li>
              <li>Garanti süresi ürün özelliğine göre değişir (1-5 yıl)</li>
              <li>Garanti belgesi ürün ile birlikte teslim edilir</li>
              <li>Yetkili servis ağı üzerinden garanti hizmeti sunulur</li>
            </ul>
            
            <h3 className="text-lg font-semibold mb-3">6.2. Satıcı Garantisi</h3>
            <ul className="list-disc list-inside mb-4 space-y-2">
              <li>Arızalı ürünlerin ücretsiz iade/değişimi</li>
              <li>Kalite kontrol garantisi</li>
              <li>Müşteri memnuniyeti garantisi</li>
              <li>Satış sonrası destek hizmeti</li>
            </ul>
            
            <h2 className="text-xl font-semibold mb-4">7. ŞİKAYET VE İTİRAZ</h2>
            <h3 className="text-lg font-semibold mb-3">7.1. Müşteri Hizmetleri</h3>
            <div className="bg-blue-50 p-4 rounded-lg mb-4">
              <p><strong>Telefon:</strong> +90 552 229 90 07</p>
              <p><strong>E-posta:</strong> info@fielhome.com</p>
              <p><strong>Çalışma Saatleri:</strong> Pazartesi-Cuma 09:00-18:00</p>
              <p><strong>Adres:</strong> MAHMUDİYE MAH. ERTUĞRUL GAZİ CAD. NO: 46 A İNEGÖL/BURSA</p>
            </div>
            
            <h3 className="text-lg font-semibold mb-3">7.2. Tüketici Hakem Heyeti</h3>
            <p className="mb-4">
              Çözümlenemeyen uyuşmazlıklar için Tüketici Hakem Heyetleri ve 
              Tüketici Mahkemelerine başvurabilirsiniz.
            </p>
            
            <h2 className="text-xl font-semibold mb-4">8. YÜRÜRLÜK</h2>
            <p className="mb-4">
              Bu ön bilgilendirme formu, sipariş verdiğiniz anda kabul etmiş sayılırsınız. 
              Sözleşme elektronik ortamda kurulmakta olup, 6502 sayılı Kanun hükümleri uygulanır.
            </p>
            
            <div className="mt-8 p-4 bg-yellow-50 border-l-4 border-yellow-400">
              <p className="text-sm text-yellow-800">
                <strong>UYARI:</strong> Sipariş vermeden önce bu bilgileri dikkatlice 
                okuyunuz. Sipariş vererek bu koşulları kabul etmiş sayılırsınız.
              </p>
            </div>
            
            <p className="mt-8 text-sm text-gray-600">
              Bu form {new Date().toLocaleDateString('tr-TR')} tarihinde güncellenmiştir.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PreliminaryInformationPage;
